import { render, staticRenderFns } from "./feature-item.vue?vue&type=template&id=1d6ed5af&scoped=true&"
import script from "./feature-item.vue?vue&type=script&lang=js&"
export * from "./feature-item.vue?vue&type=script&lang=js&"
import style0 from "./feature-item.vue?vue&type=style&index=0&id=1d6ed5af&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6ed5af",
  null
  
)

export default component.exports